export default "__VITE_ASSET__DDmPa87l__"